import ApiActions from 'go/actions/api';
import {connect} from 'react-redux';
import {ACCEPTED_FILE_SIZE} from 'app-ui-componentlibrary/dist/common/constants';
import _ from 'lodash';
import CollaborationActions from 'go/actions/api/collaboration';

export const FileTransferUtils = {
  createFormData: (
    file,
    attachmentType,
    entityId,
    entityType,
    organizationId,
    subOrgId,
    programId,
    categoryId,
    visibility,
    task,
    process
  ) => {
    let form = new FormData();
    // TODO update this when service changes to entityId
    form.append('entityId', entityId);
    form.append('organizationId', organizationId);
    if (!_.isUndefined(subOrgId)) {
      form.append('subOrgId', subOrgId);
    }
    if (!_.isUndefined(programId)) {
      form.append('programId', programId);
    }
    form.append('categoryId', categoryId);
    // will take a hardcoded prop for cases where there is no workflow context
    form.append('task', task);
    form.append('process', process);
    form.append('entityType', entityType);
    form.append('attachmentType', attachmentType);
    form.append('visibility', visibility);
    form.append('submissionId', file.submissionId);
    form.append('file', file.file, file.fileName);
    return form;
  },
  createPayload: (tobeUpdated) => {
    let jsonArray = [];
    let payload = {};
    payload.organizationId = tobeUpdated.organizationId;
    payload.subOrgId = tobeUpdated.subOrgId;
    payload.programId = tobeUpdated.programId;
    payload.description = tobeUpdated.description;
    payload.resourceId = tobeUpdated.resourceId;
    if (tobeUpdated.categoryId) {
      payload.categoryId = tobeUpdated.categoryId;
    }
    jsonArray.push(payload);
    return JSON.stringify(jsonArray);
  },
};

export default FileTransferUtils;

export const mapDispatchToProps = (dispatch) => ({
  uploadAttachment: (token, formData, collaborationRoomName) => {
    const action = ApiActions.attachments.uploadAttachment(token, formData);
    const response = dispatch(action);
    if ( collaborationRoomName ) {
      response.then( (result) => {
        dispatch(CollaborationActions.refetchRoom({roomName: collaborationRoomName}))
        return result;
      })
    }
    return response;
  },
  retrieveAttachmentsForEntity: (token, entityId, entityType, filterOptions) => {
    const action = ApiActions.attachments.retrieveAttachmentsForEntity(
      token,
      entityId,
      entityType,
      filterOptions
    );
    const response = dispatch(action);
    return response;
  },
  deleteAttachment: (token, resourceId, collaborationRoomName) => {
    const action = ApiActions.attachments.deleteAttachment(token, resourceId);
    const response = dispatch(action);
    if ( collaborationRoomName ) {
      response.then( (result) => {
        dispatch(CollaborationActions.refetchRoom({roomName: collaborationRoomName}))
        return result;
      })
    }

    return response;
  },
});

export const withAttachmentApi = (component) =>
  connect(() => ({}), mapDispatchToProps)(component);

export const convertFileSize = (fileSize, fileSizeLimit) => {
  fileSizeLimit = fileSizeLimit === undefined ? ACCEPTED_FILE_SIZE : fileSizeLimit;
  let unit = 'B';
  const i = Math.floor(Math.log(fileSize) / Math.log(fileSizeLimit)),
    sizes = ['KB', 'MB', 'GB', 'TB'];
  // i represents power of 1024 byte. power 1 represents KB level, power 2 represents MB level, 3 represents GB level, 4 represents TB level
  const filesizeConvertToProperUnit = (fileSize / Math.pow(fileSizeLimit, i)).toFixed(0);
  const sizeIndex = i - 1; // the size array start from 0. So KB level power 1 should minus 1 to 0. Same calculation for MB, GB and TB level.
  if (sizeIndex >= 0) unit = sizes[i - 1];
  return filesizeConvertToProperUnit + ' ' + unit;
};
